var _g, _use, _g2, _use2, _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLayoutCustom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 420,
    viewBox: "0 0 600 420",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hex"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "124.2,15 197.4,60 197.4,150 124.2,195 51,150 51,60",
    fill: "currentColor",
    stroke: "#808080",
    strokeWidth: 2
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#hex",
    x: 0,
    y: 205
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "rhombus",
    transform: "translate(-75, 100) rotate(60 520 70)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "460,70 570,130 460,200 350,140",
    fill: "currentColor",
    stroke: "#808080",
    strokeWidth: 2
  }))), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    href: "#rhombus",
    x: 0,
    y: 120
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 60,
    width: 100,
    height: 100,
    fill: "currentColor",
    stroke: "#808080",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 160,
    width: 100,
    height: 100,
    fill: "currentColor",
    stroke: "#808080",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 260,
    width: 100,
    height: 100,
    fill: "currentColor",
    stroke: "#808080",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayoutCustom);
export default __webpack_public_path__ + "static/media/layout-custom.b07df8a7c259337c282eb9bea7b15167.svg";
export { ForwardRef as ReactComponent };